import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWebdavIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 256 256",
	width: "100%",
	height: "100%",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "currentColor",
		fillRule: "nonzero",
		stroke: "none",
		strokeWidth: 1,
		strokeLinecap: "butt",
		strokeLinejoin: "miter",
		strokeMiterlimit: 10,
		strokeDasharray: "",
		strokeDashoffset: 0,
		fontFamily: "none",
		fontWeight: "none",
		fontSize: "none",
		textAnchor: "none",
		style: { mixBlendMode: "normal" },
		children: /* @__PURE__ */ _jsx("g", {
			transform: "scale(5.12,5.12)",
			children: /* @__PURE__ */ _jsx("path", { d: "M5.71875,12.96875c0,0 0.33203,0.92578 0.125,1.65625c-0.21094,0.73047 -3.75,16.69531 -5,22.21875c-0.21094,1.14453 -0.84375,1.65625 -0.84375,1.65625h10c6.35938,0 12.09375,-8.23437 12.09375,-17.09375c0,-8.85937 -8.125,-8.4375 -7.1875,-8.4375zM23.15625,13.5c0,0 0.29297,0.3125 0.1875,0.9375c0,0 -0.14844,0.59766 -0.40625,1.59375c0.71094,1.40625 1.15625,3.15234 1.15625,5.375c0,6.65234 -2.82422,12.75 -6.875,16.1875c-0.14844,0.57031 -0.21875,0.90625 -0.21875,0.90625h4.90625l1.25,-5.09375h6.5625l1.25,5.09375h6.5625c0,0 -7.39453,-23.54297 -7.5,-24.0625c-0.10547,-0.51953 0.09375,-0.9375 0.09375,-0.9375zM32.375,13.5l-0.34375,0.65625c0.58594,1.98047 4.66406,15.02344 7.40625,23.75l0.21875,0.71875h3.90625c0,0 -0.82422,-1.25 -0.71875,-2.1875c0.10547,-0.73047 0.53125,-2.40625 0.53125,-2.40625c0,0 5.92578,-19.1875 6.03125,-19.5c0.10547,-0.3125 0.625,-0.9375 0.625,-0.9375h-5.53125c0,0 0.74219,0.51953 0.53125,0.9375c-0.21094,0.41797 -4.59375,15.75 -4.59375,15.75l-3.96875,-16.78125zM11.375,16.625h1.875c0.625,0 3.3125,0.21484 3.3125,5.53125c0.00391,5.31641 -3.73828,12.59375 -6.65625,12.59375h-2.9375zM26.46875,21.71875l2.40625,8.03125h-5.09375z" })
		})
	})
});
export default SvgWebdavIcon;
